<app-vente-pricing *ngIf="dossierBien.typeDossier === 'vente'" [vente]="vente"></app-vente-pricing>

<app-location-pricing *ngIf="dossierBien.typeDossier === 'location'" [location]="location"></app-location-pricing>
